module.exports = __webpack_public_path__ + "static/media/Icon_Vermelho.45bc2f2a.svg";